import { mtop } from '../../utils';
import { message } from 'antd';

export default {
  namespace: 'accountRegister',
  state: {
    registerInfo: {},
    registerStatus: '',
    codeStatus: false,
    stepOneSubmitStatus: false,
  },
  reducers: {
    setRegisterInfo(state, { payload: registerInfo }) {
      return {
        ...state,
        registerInfo,
      };
    },
    setRegisterStatus(state, { payload: registerStatus }) {
      return {
        ...state,
        registerStatus,
      };
    },
    setCodeStatus(state, { payload: codeStatus }) {
      return {
        ...state,
        codeStatus,
      };
    },
    setStepOneSubmitStatus(state, { payload: stepOneSubmitStatus }) {
      return {
        ...state,
        stepOneSubmitStatus,
      };
    },
  },
  effects: {
    // 第一步提交
    * confirmRegister({ payload }, { put, call }) {
      try {
        const response = yield call(mtop, 'register.stepone.submit', {
          ...payload,
        });
        yield put({type: 'setStepOneSubmitStatus', payload: true});
      } catch (error) {
        message.error(error.msg);
        yield put({type: 'setStepOneSubmitStatus', payload: error.msg});
      }
    },
    // 获取企业及法人信息
    * getRegisterInfo({payload}, {put, call}) {
      try {
        // const response = yield call(mtop, 'register.providerinfo.stepone.get', {
        const response = yield call(mtop, 'register.providerinfo.apply.get', {
          ...payload,
        });
        yield put({type: 'setRegisterInfo', payload: response});
      } catch (error) {
        message.error(error.msg);
        yield put({type: 'setRegisterInfo', payload: {}});
      }
    },
    // 获取用户注册状态
    * getRegisterStatus({payload}, {put, call}) {
      try {
        const response = yield call(mtop, 'index.status', {
          ...payload,
        });
        yield put({type: 'setRegisterStatus', payload: response});
      } catch (error) {
        message.error(error.msg);
        yield put({type: 'setRegisterStatus', payload: {}});
      }
    },
    // 获取短信校验码
    * getVerifyCode({payload}, {put, call}) {
      try {
        const response = yield call(mtop, 'message.send', {
          ...payload,
        });
      } catch (error) {
        message.error(error.msg);
      }
    },
    // 验证短信校验码
    * checkVerifyCode({payload}, {put, call}) {
      try {
        const response = yield call(mtop, 'register.stepone.verifycode', {
          ...payload,
        });
        yield put({type: 'setCodeStatus', payload: true});
      } catch (error) {
        // message.error(error.msg);
        yield put({type: 'setCodeStatus', payload: error.msg});
      }
    },
  },
};


// WEBPACK FOOTER //
// ./src/models/account/register.js